import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ascend, compose, find, groupWith, sortWith, descend, prop, sum, defaultTo, pathEq, isEmpty } from 'ramda';

import { routes } from '../../routes';

const mapStore = ({ fellowshipServiceTypes }) => ({ fellowshipServiceTypes });

class ExperiencesList extends Component {
  static propTypes = {
    admin: PropTypes.bool,
    registration: PropTypes.object,
    experiences: PropTypes.array,
    fellowshipServiceTypes: PropTypes.array,
  };

  renderInfoRow = (name, value) => {
    if (!value) return <noscript />;

    return (
      <p>
        <strong>{name}:</strong> {value}
      </p>
    );
  };

  renderExperienceRow = (experience) => {
    const { admin } = this.props;
    let status = 'Pending';
    if (experience.approved === true) {
      status = 'Approved';
    } else if (experience.approved === false) {
      status = 'Rejected';
    }
    return (
      <tr key={experience.id}>
        <td>{experience.organization}</td>
        <td>{experience.hours}</td>
        <td>{experience.startDate}</td>
        <td>{experience.endDate}</td>
        <td>
          <Link
            className="btn btn-link btn-sm"
            to={
              admin
                ? routes.admin.experiences.reviewBuilder(experience.id)
                : routes.certificationsAndTraining.experience.editBuilder(experience.id)
            }
          >
            {status}
          </Link>
        </td>
      </tr>
    );
  };

  render() {
    const { experiences, fellowshipServiceTypes, registration } = this.props;
    const filteredServiceTypes = fellowshipServiceTypes.filter(
      (type) => !type.militarySpouseOnly || registration.militarySpouse,
    );
    const groupedExperiences = compose(
      groupWith((a, b) => a.fellowshipServiceTypeId == b.fellowshipServiceTypeId),
      sortWith([ascend(prop('fellowshipServiceTypeId')), descend(prop('startDate'))]),
    )(experiences);
    const experiencesWithoutServiceType = defaultTo(
      [],
      find(pathEq(['0', 'fellowshipServiceTypeId'], null), groupedExperiences),
    );

    return (
      <div className="table-responsive">
        <table className="table table-sm">
          <thead>
            <tr>
              <th>Organization</th>
              <th>Hours</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {filteredServiceTypes.map((serviceType) => {
              const experienceHours = defaultTo(
                [],
                find(pathEq(['0', 'fellowshipServiceTypeId'], serviceType.id), groupedExperiences),
              );

              if (isEmpty(experienceHours) && serviceType.deletedAt != null) return <noscript />;

              const totalHours = sum(experienceHours.map((experience) => (experience.approved ? experience.hours : 0)));
              const maxHoursAllowed = serviceType.percentage
                ? Math.round(registration.requiredHours * (serviceType.allowed * 0.01))
                : serviceType.allowed;
              return (
                <Fragment key={serviceType.id}>
                  <tr className="table-active font-weight-bold">
                    <td colSpan={5}>
                      {serviceType.name} (Approved hours: {totalHours} / Max Allowed: {maxHoursAllowed})
                    </td>
                  </tr>
                  {experienceHours.map(this.renderExperienceRow)}
                </Fragment>
              );
            })}
            {experiencesWithoutServiceType.map(this.renderExperienceRow)}
          </tbody>
        </table>
      </div>
    );
  }
}

export default compose(withRouter, connect(mapStore))(ExperiencesList);
